var _a, _b;
const defaultConfig = {
    // List of supported types
    supportedTypes: [
        'casinogame',
        'match',
        'event',
        'promotion',
        'race',
        'league',
        'selection',
        'sport',
        'static',
    ],
    // URL where all resources are put
    // FIXME: document.currentScript not supported in Internet Explorer.
    searchCdnUrl: ((_b = (_a = document.currentScript) === null || _a === void 0 ? void 0 : _a.src) === null || _b === void 0 ? void 0 : _b.replace(/\/[^/]+$/, '')) || '',
};
export function fulfillConfig() {
    var _a;
    // @ts-ignore: using possible global variable
    if (window.$whSearch && !((_a = window.$whSearch) === null || _a === void 0 ? void 0 : _a.$fulfilled)) {
        // @ts-ignore: ensuring all defaults are included
        window.$whSearch = Object.assign(Object.assign({ $fulfilled: true }, defaultConfig), window.$whSearch);
    }
}
export function getConfig() {
    // Ensure that all default will be included, and the config will not be duplicated
    fulfillConfig();
    // @ts-ignore: using possible global variable
    return window.$whSearch || defaultConfig;
}
export const DEFAULT_FILTER_TAB = { id: 'all', name: 'All', slug: 'all' };
export const CASINOGAME_FILTER_TAB = { id: 'casinogame', name: 'Gaming', slug: 'gaming' };
export const PROMOTION_FILTER_TAB = { id: 'promotion', name: 'Promotions', slug: 'promotions' };
export const SEARCH_VERSION = 'v2';
export const DEFAULT_URL_CONFIG = {
    sportsbookBaseUrl: 'https://sports.williamhill',
    launcherBaseUrl: 'https://launcher.williamhill',
    searchBaseUrl: 'https://search.williamhill',
};
export const DEFAULT_LOCALE = 'en-gb';
export const JURISDICTIONS = {
    com: 'com',
    es: 'es',
};
export const ENVIRONMENTS = {
    pp1: 'pp1',
    prd: 'prd',
};
export const localeMap = {
    'en-gb': 'en',
    'es-es': 'es',
};
//# sourceMappingURL=config.js.map